module.exports = __webpack_public_path__ + "img/marketing_map_5.45e0dd15.png";